import { Component, OnInit } from '@angular/core';
import { ServicioAnexoIIService, AnexoIIEntity } from 'src/app/services/servicio-anexoII.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reporte-anexo-ii',
  templateUrl: './reporte-anexo-ii.component.html',
  styleUrls: ['./reporte-anexo-ii.component.css']
})
export class ReporteAnexoIIComponent implements OnInit {

  uncoAtencionInicialUrgencia: number;
  codigoBaseDatos: string;
  ready: boolean;

  public anexoEntityII: AnexoIIEntity;

  constructor(
    private activatedRoute: ActivatedRoute,
    private servicioAnexoII: ServicioAnexoIIService,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.codigoBaseDatos = params['codigoBaseDatos'];
      this.uncoAtencionInicialUrgencia = params['uncoAtencionInicialUrgencia'];
    });

    this.getReport();
  }

  ngOnInit() {

  }

  private async getReport() {

    try {

      const response = await this.servicioAnexoII.getBodyReport(this.codigoBaseDatos, this.uncoAtencionInicialUrgencia);

      if (response != null) {
        response.subscribe((data: any) => {
          if (typeof data['error'] !== 'undefined') {
            if (data.error) {
              console.error(data);
            }
            const dataTmp = data.data;
            for (const key in dataTmp) {
              if (typeof dataTmp[key] === 'string') {
                if (dataTmp[key] === 'null') {
                  dataTmp[key] = '';
                } else {
                  dataTmp[key] = String(dataTmp[key]).trim();
                }
                
              } else if (dataTmp[key] === null) {
                dataTmp[key] = '';
              }
            }
            this.anexoEntityII = dataTmp;
            this.ready = true;
          }
        });
      }
    } catch (exception) {
      console.error(exception);
    }
  }

  public getPrint() {
    window.print();
  }

  public 

}
